import React, { useEffect, useState } from 'react'
import SupplyOrderFormItem from './SupplyOrderFormItem'
import MyButton from '../../../../UI/form/MyButton'
import { addValueObjInArrayForm, checkValid, deleteObjInArrayForm, deleteValidateById, updateValidate, updateValidateInArrayForm, updateValueObjInArrayForm } from '../../../../../helpers/form/FormHelper'

const SupplyOrderFormItems = ({ required, setValidate, setValueForm, forciblyValue }) => {

	const [supplyOrderItems, setSupplyOrderItems] = useState(forciblyValue ? forciblyValue : [])
	const [disabled, setDisabled] = useState(false)

	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [isCanDeleted, setIsCanDeleted] = useState(false) // Можливість видалення
  	// Тут скоріш за все реалізувати позиції через стор. 

	// console.log('supplyOrderItems', supplyOrderItems)
	// console.log('valid', valid)

	useEffect(() => {
		validMaxItems()
		changeIsCanDeleted()
		setValueForm(supplyOrderItems)
	}, [supplyOrderItems])

	useEffect(() => {
		// checkValid(valid, setIsValidForm)
		checkValid(valid, setValidate)
	}, [valid])

	useEffect(() => { // За замовчуванням додаємо перший елемент завжди
		if (supplyOrderItems && supplyOrderItems.length === 0) {
			addValueObjInArrayForm(setSupplyOrderItems, {})
		}
	}, [])

	const addItem = () => {
		// addValueInArrayForm(setSupplyOrderItems, {id: 'fsdfdsf'})
		addValueObjInArrayForm(setSupplyOrderItems, {})
		// setSupplyOrderItems([{}])
		setDisabled(false)
	}

	const validMaxItems = () => { // Заборона на внесення більше 10 позицій
		// if (supplyOrderItems && supplyOrderItems.length >= 10) {
		if (supplyOrderItems && supplyOrderItems.length >= 300) {
			setDisabled(true)
		} else {
			setDisabled(false)
		}
	}

	const changeIsCanDeleted = () => { // Заборона на внесення більше 10 позицій
		if (supplyOrderItems && supplyOrderItems.length > 1) {
			setIsCanDeleted(true)
		} else {
			setIsCanDeleted(false)
		}
	}

  return (
    <div className='myFormSimple__listBlock'>
		{
			supplyOrderItems && supplyOrderItems.length > 0 ?
				supplyOrderItems.map((supplyOrderItem, index) => {
					return (
						<SupplyOrderFormItem 
							key={supplyOrderItem.id}
							index={index}
							supplyOrderItem={supplyOrderItem}
							// setValidate={e => updateValidateInArrayForm(setValid, supplyOrderItem.id, e)}
							setValidate={e => updateValidate(setValid, supplyOrderItem.id, e)}
							setValueFormItem={e => updateValueObjInArrayForm(setSupplyOrderItems, supplyOrderItem.id, e)}
							// forciblyValue={supplyOrderItem ? supplyOrderItem : ''}
							deleteItem={e => {
								deleteObjInArrayForm(setSupplyOrderItems, supplyOrderItem.id)
								deleteValidateById(setValid, supplyOrderItem.id)
							}}
							isCanDeleted={isCanDeleted}
						/>
					)
				})
			: ''
		}
		<MyButton
			onClick={e => {
				setDisabled(true)
				addItem()
			}}
			disabled={disabled}
		>
			Додати позицію
		</MyButton>
    </div>
  )
}

export default SupplyOrderFormItems